import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

const CustomCancelationReason = Loadable(
    lazy(() =>
        import("./customCancelationReason").then(({ CustomCancelationReason }) => ({
            default: CustomCancelationReason,
        }))
    )
);

export const CustomCancelationReasonRoutes = [
    {
        path: "/custom-cancellation-reason",
        exact: true,
        element: (
            <AuthorizedRoute
               
                moduleIds={[ALLOWED_MODULES.CUSTOM_CANCELLATION_REASON]}
            >
                <CustomCancelationReason />
            </AuthorizedRoute>
        ),
    },
];
